import { BackIconRounded } from '@va/icons';
import { Button, fontWeights, ParagraphWithTooltip } from '@va/ui/design-system';
import { ReactNode, useEffect, useRef } from 'react';

export const SubFilterTabHeader = ({
  onBackClick,
  title,
  endAdornment,
}: {
  onBackClick: () => void;
  title: string;
  endAdornment?: ReactNode;
}) => {
  const backButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    backButtonRef.current?.focus();
  }, []);

  return (
    <div className='mb-2'>
      <div className='flex items-center'>
        <Button
          ref={backButtonRef}
          className='mr-3 scale-75'
          color='tertiary'
          icon={() => <BackIconRounded />}
          onClick={onBackClick}
        />
        <ParagraphWithTooltip weight={fontWeights.medium} colorClassName='text-gray-charcoal'>
          {title}
        </ParagraphWithTooltip>
        {endAdornment}
      </div>

      <div className='h-1.5px bg-gradient-to-r from-gray-gallery-darker via-gray-concrete to-white -mx-1'></div>
    </div>
  );
};
